	export enum InsurancePlanFilingMethodEnum {
		Electronic = 1,
		Paper = 2,
		Excel = 3
	}
